const startTime = 1 * new Date();

/**
 * Return maximun time to wait or 0
 *
 * @param {Number} maxTime Maximum time to wait
 * @returns {Number}
 */
function timeFromBegin(maxTime) {
  const diffTime = (1 * new Date()) - startTime;

  return Math.max((maxTime - diffTime), 0);
}

export default timeFromBegin;
